import styled from 'styled-components';
import { AdaptiveColumnContainer, FlexColumn } from '../../styled/common';
import { Typography } from '../ui/Typography';
import { tagStyles } from '../ui/Typography/styles';
import { Breakpoints } from '../../styled/constants';
import { CustomLink } from '../CustomLink';

export const SitemapPageContainer = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    #sitemap_mobile_header {
      display: none;
    }
  }
`;

export const SitemapLink = styled(CustomLink)`
  text-decoration: none;

  &,
  & > span {
    color: ${({ theme: { colors } }) => colors.systemColors.blue};
  }
`;

export const SitemapPageBackground = styled(FlexColumn)`
  width: 100vw;
  align-items: center;
  padding-top: 5px;
  background-color: ${({ theme: { colors } }) => {
    return colors.background.tertiary;
  }};

  @media screen and (min-width: ${({ theme }) =>
      theme.tabletBreakpoint}) and (max-width: ${({ theme }) =>
      theme.desktopBreakpoint}) {
    padding: 0 40px;
  }

  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    padding: 0 80px;
  }
`;

export const SitemapLayout = styled(FlexColumn)`
  width: 100%;
  max-width: ${Breakpoints.desktop}px;
  flex: auto;
  margin: 0 0 30px;
  background-color: #fefefe;
  padding: 30px 15px;
  border-radius: 21px;
  gap: 50px;

  @media screen and (min-width: ${({ theme }) =>
      theme.tabletBreakpoint}) and (max-width: ${({ theme }) =>
      theme.desktopBreakpoint}) {
    padding: 40px 30px;
  }

  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    padding: 60px 50px;
  }
`;

export const SitemapTitle = styled(Typography)`
  max-width: ${Breakpoints.desktop}px;
  width: 100%;
  flex: auto;
  margin: 40px 0;

  font-size: 24px;
  font-weight: 700;

  @media screen and (min-width: ${({ theme }) =>
      theme.smallDesktopBreakpoint}) {
    font-size: 32px;
  }

  @media screen and (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
    display: none;
  }
`;
export const SitemapEntryContainer = styled(AdaptiveColumnContainer)`
  gap: 25px;

  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    gap: 20px;
  }
`;

export const SitemapSectionEntryContainer = styled(AdaptiveColumnContainer)`
  gap: 15px;
`;

export const SitemapSectionTitle = styled.h2`
  margin: 0;
  ${tagStyles.h5_new};

  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    font-size: 24px;
  }
`;

export const SitemapSectionContainer = styled(FlexColumn)`
  gap: 30px;

  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    gap: 40px;
  }
`;
